import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgElatedSelectedEmojiSecondary from './svgs/ElatedSelectedEmojiSecondary.js';
import SvgElatedSelectedEmoji from './svgs/ElatedSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var elatedSelectedEmoji = (props => useIcon(SvgElatedSelectedEmoji, SvgElatedSelectedEmojiSecondary, props));

export { elatedSelectedEmoji as default };
